import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const initialContext = {
  value: undefined,
  depth: 0,
  activeVariant: 'default'
};
const SideNavContext = /*#__PURE__*/createContext(initialContext);
export const SideNavContextProvider = ({
  children,
  value,
  depth,
  activeVariant = 'default'
}) => {
  const providerValue = {
    value,
    depth,
    activeVariant
  };
  return /*#__PURE__*/_jsx(SideNavContext.Provider, {
    value: providerValue,
    children: children
  });
};
export const useSideNavContext = () => {
  const sideNavContext = useContext(SideNavContext);
  if (!sideNavContext) {
    throw new Error('useSideNavContext must be used within SideNavContextProvider');
  }
  return sideNavContext;
};